import { call, put, retry } from "redux-saga/effects"
import { storeApiLoading } from "actions"

export function* callApi(api, params) {
  try {
    yield put(storeApiLoading(true))
    const payload = yield retry(3, 1, execApi, api, params)
    return { payload }
  } catch (error) {
    return { error }
  } finally {
    yield put(storeApiLoading(false))
  }
}
export function* execApi(api, params) {
  const { payload, error } = yield call(api, params)
  if (payload && !error) {
    return payload
  }
  throw Error(error)
}
